//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const slugify = require('speakingurl');

export default {
  props: ['event'],
  methods: {
    formatTime: function (starts_at) {
        return this.$date(starts_at).startsIn();
    },
    getURL: function (event) {
      return this.localePath({ name: 'match-screen', params: {
        sport: _.get(event, 'translated_sport_slug'),
        slug: slugify(event.name) + '-' + this.getEventId(event.id),
        competition: _.get(event, 'competition_slug'),
      }})
    },
    goBack() {
      this.$router.back()
    }
  }
}
